module.exports = __webpack_public_path__ + "static/media/lemonbread.77b64940.jpg";